import useLocale from "@Hooks/selector/useLocale";
import {LocaleType} from "@/types/Locale.type";

export default function useGetGbtSupportedLocale(): "en" | "de" | "it" | "fr" | "es" {
    const locale = useLocale(false) as LocaleType

    const gbbToGbtLocaleMapper: Record<string, "en" | "de" | "it" | "fr" | "es"> = {
        [`${locale === "en" || locale === "en-us" || locale === "en-gb"}`]: "en",
        [`${locale === "de"}`]: "de",
        [`${locale === "it"}`]: "it",
        [`${locale === "fr"}`]: "fr",
        [`${locale === "es" || locale === "es-ar"}`]: "es",
    }

    return gbbToGbtLocaleMapper?.true ?? "en"
}